<template>
  <div class="contact-box-container" :class="config.layout">
    <tile-contact-box v-if="config.layout === 'tile'" @showContactForm="showContactForm">

    </tile-contact-box>
    <legacy-contact-box v-if="config.layout !== 'inline' && config.layout !== 'tile' && config.legacy === '1'"
      :contact="currentContact" :requestTypes="filteredRequestTypes"
      @showContactForm="showContactForm"></legacy-contact-box>
    <extended-contact-box v-if="config.layout !== 'inline' && config.layout !== 'tile' && config.legacy !== '1'"
      :contact="currentContact" @showContactForm="showContactForm"></extended-contact-box>
    <Modal :title="labels.get('Get in contact')" v-if="showForm && config.layout !== 'inline'" @close="showForm = false">
      <div v-if="!isSubmitting" class="form-container">
        <contact-form class="visible" ref="theModalForm"></contact-form>
        <FlatButton blue inline-right :label="labels.get('Submit')" @click="onSubmit"></FlatButton>
      </div>
      <SubmitForm ref="modalSubmitForm" v-if="isSubmitting" :class="{ visible: isSubmitting }" @back="onBack()"
        @close="onClose()"></SubmitForm>
    </Modal>
    <div class="inline-contact-form-container" v-if="config.layout === 'inline'">
      <div v-if="!isSubmitting" class="form-container">
        <contact-form class="visible" ref="theInlineForm"></contact-form>
        <FlatButton blue inline-right :label="labels.get('Submit')" @click="onSubmit"></FlatButton>
      </div>
      <SubmitForm ref="inlineSubmitForm" v-if="isSubmitting" :class="{ visible: isSubmitting }" @back="onBack()"
        @close="showForm = false"></SubmitForm>
    </div>
  </div>
</template>

<script>
import ServiceManager from "../services/service-manager";
import ContactCard from "./ContactCard.vue";
import ContactForm from "./ContactForm.vue";
import SubmitForm from "./SubmitForm.vue";
import Modal from "./Modal.vue";
import { DropList, FlatButton } from "clariant-vue3-forms";
import LegacyContactBox from './LegacyContactBox.vue';
import TileContactBox from './TileContactBox.vue';
import ExtendedContactBox from "./ExtendedContactBox.vue";

export default {
  name: "ContactBox",
  components: {
    ContactCard,
    Modal,
    DropList,
    FlatButton,
    ContactForm,
    SubmitForm,
    LegacyContactBox,
    TileContactBox,
    ExtendedContactBox
  },
  props: ["vertical"],
  data() {
    return {
      labels: ServiceManager.getService(this, "Labels"),
      config: ServiceManager.getService(this, "Config"),
      state: ServiceManager.getService(this, "State"),
      dataLayer: ServiceManager.getService(this, "DataLayer"),
      utils: ServiceManager.getService(this, "Utils"),
      requestTypes: [],
      requestType: "",
      currentContact: null,
      showForm: false,
      isSubmitting: false,
    };
  },
  setup() {
    return {
      uniqueId: `ContactBox-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`
    }
  },
  mounted() {
    this.state.subscribe(
      this.uniqueId,
      this.onStateChanged
    );
    this.requestTypes = this.dataLayer.loadRequestTypes();
    this.loadContact();
  },
  beforeUnmount() {
    this.state.unsubscribe(this.uniqueId);
  },
  computed: {
    filteredRequestTypes() {
      if (!this.currentContact) return [];
      if (!this.currentContact.topics || this.currentContact.topics.length === 0) return this.requestTypes;
      return this.requestTypes.filter(x => this.currentContact.topics.includes(x.id));
    }
  },
  methods: {
    onStateChanged(msg, prop, value) {
      if (prop === "requestTypes") {
        this.requestTypes = value;
        this.requestType =
          this.requestTypes && this.requestTypes.length > 0
            ? this.requestTypes[0].id
            : "";
      }
    },
    loadContact() {
      let loader = this.utils.showLoader(this.$el);
      this.dataLayer
        .getSuitableContact(
          this.config.contactId,
          this.config.buId,
          this.config.blId,
          this.config.contactTagId
        )
        .then((res) => {
          //if we got here, we should have a contact
          this.currentContact = res.data;

          this.state.atomicUpdate("reload", {
            currentContact: this.config.contactId,
            bu: this.config.buId || this.currentContact.buGuids,
            bl: this.config.blId || this.currentContact.blGuids,
          });
        })
        .catch((err) => {
          this.utils.showStatusMessage(
            `Could not load contact details. Error: ${err.message}.`,
            "red"
          );
        })
        .finally(() => {
          this.utils.removeLoader(loader);
        });
    },
    showContactForm(topic) {
      if (topic) {
        this.requestType = topic;
      }
      this.showForm = true;
      this.$nextTick(() => {
        this.state.atomicUpdate("reload", {
          currentContact: this.currentContact.id,
          bu: this.config.buId,
          bl: this.config.blId,
        });
      });
    },
    onBack() {
      this.isSubmitting = false;
      this.showContactForm();
    },
    onClose() {
      this.isSubmitting = false;
      this.showForm = false;
    },
    onSubmit() {
      let form =
        this.config.layout === "inline"
          ? this.$refs.theInlineForm
          : this.$refs.theModalForm;
      if (!form) return;
      if (!form.validateForm()) return;

      let formPayload = form.getFormPayload();

      this.isSubmitting = true;
      this.$nextTick(() => {
        let submitStep =
          this.config.layout === "inline"
            ? this.$refs.inlineSubmitForm
            : this.$refs.modalSubmitForm;
        submitStep.submitForm(formPayload);
      });
    },
  },
};
</script>

<style scoped>
.contact-box-container:not(.inline):not(.tile) {
  display: flex;
  flex-direction: column;
}

.form-container {
  display: flex;
  flex-direction: column;
}

.branded-button.inline-right {
  align-self: flex-end;
  min-width: 160px;
}
</style>